import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faChartLine,
  faCalculator,
  faWarning,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';
import { getAlerts } from 'services/alertsService';
import { AlertData } from 'types';
import { useKeycloak } from '@react-keycloak/web';

interface NavigationProps {}

const Navigation: React.FC<NavigationProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [alerts, setAlerts] = useState<AlertData[]>([]);
  const { keycloak } = useKeycloak();

  const buttons = [
    { path: '/home', icon: faHome, label: 'Home' },
    { path: '/trends', icon: faChartLine, label: 'Trends' },
    { path: '/tariffs', icon: faCalculator, label: 'Rates' },
    { path: '/alerts', icon: faWarning, label: 'Alerts' },
    { path: '/logout', icon: faSignOutAlt, label: 'Logout' },
  ];

  const handleNavigation = (path: string) => {
    if (path === '/logout') {
      keycloak.logout();
      return;
    }
    navigate(path);
  };

  useEffect(() => {
    const fetchAlerts = async () => {
      const alertsData = await getAlerts(
        'temperature,gas_consumption_rate,instantaneous_usage_rate,daily_threshold'
      );
      setAlerts(alertsData);
    };

    fetchAlerts();
  }, []);

  return (
    <div className="container mx-auto flex justify-start pl-6">
      <div className="mb-6 flex space-x-6">
        {buttons.map((button) => (
          <button
            key={button.path}
            className={`relative rounded bg-background p-2 text-5xl ${
              location.pathname.startsWith(button.path)
                ? 'text-blue-500'
                : 'text-white'
            } ${button.label === 'Logout' ? 'text-red-500 hover:text-red-700' : ''}`}
            onClick={() => handleNavigation(button.path)}
            title={button.label} // This adds a tooltip
          >
            <FontAwesomeIcon icon={button.icon} />
            {button.label === 'Alerts' && (
              <span className="absolute bottom-0 left-10 mr-2 mt-2 flex h-6 w-6 items-center justify-center rounded-full bg-red-500 text-sm text-white">
                {alerts.length > 0 ? alerts.length : null}
              </span>
            )}
            {button.label === 'Logout' && (
              <span className="absolute bottom-[-20px] left-1/2 -translate-x-1/2 transform text-xs text-white">
                Logout
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Navigation;
